import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `previousYearFormulaNode` is a concrete implementation of `wrapperFormulaNode`
 * representing a previous year node.
 *
 * @param {number} spec.numYears - number of years to go back
 */

/**
 * TODO: write documentation
 */
export default class PreviousYearFormulaNode extends WrapperFormulaNode {
	constructor({ numYears } = {}) {
		super(...arguments);
		this._numYears = numYears;
	}

	getNumYears() {
		return this._numYears;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitPreviousYearNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.numYears = this._numYears;

		return properties;
	}

	static getType() {
		return "PreviousYearNode";
	}
}
